import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header1 = () => {
  const [show, setShow] = useState(true);
  const [showUpload, setShowUpload] = useState(true);
  const url = useLocation();
  const [showdash, setShowDash] = useState(true);

  useEffect(() => {
    if (
      url.pathname.includes("report") ||
      url.pathname.includes("uploadfiles") ||
      url.pathname.includes("dashboard")
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [url]);

  useEffect(() => {
    if (url.pathname.includes("uploadfiles")) {
      setShowUpload(false);
    } else {
      setShowUpload(true);
    }
  }, [url]);

  useEffect(() => {
    if (url.pathname.includes("dashboard")) {
      setShowDash(false);
    } else {
      setShowDash(true);
    }
  }, [url]);

  return (
    <div className="w-full bg-404A52 h-[72px] flex justify-between items-center px-6 sm:px-10">
      <div className="w-fit sm:w-4/12 flex justify-start items-center gap-10">
        {/* <h1 className="text-white text-20 font-medium">Xpert Xpress</h1> */}
        {showdash ? (
          <Link to={"/dashboard"} className="text-16 font-semibold text-white">
            Dashboard
          </Link>
        ) : (
          ""
        )}
      </div>
      {url.pathname.includes("report") && ( <div className="w-4/12">
       
          <p className="text-24 font-semibold text-[#FEB13F]">
            {" "}
            Content and Integrity Report
          </p>
        
      </div>)}

      <div className="w-fit sm:w-4/12 flex gap-4 justify-end">
        {show ? (
          <div className="flex gap-[6px] items-center p-3">
            <img
              src={process.env.PUBLIC_URL + "/images/header/history.png"}
              alt="icon"
            />
            <Link
              to={"/filehistory"}
              className="text-16 font-semibold text-white"
            >
              File History
            </Link>
          </div>
        ) : (
          ""
        )}

        {showUpload ? (
          <div className="flex gap-[6px] items-center p-3">
            <img
              src={process.env.PUBLIC_URL + "/images/header/history.png"}
              alt="uploads"
            />
            <Link
              to={"/uploadfiles"}
              className="text-16 font-semibold text-white"
            >
              Upload
            </Link>
          </div>
        ) : (
          ""
        )}
        {/* {show ? (
          <Link
            to={"/filehistory"}
            className="px-8 py-3 bg-white rounded-[36px] text-E63946 font-semibold"
          >
            Next Page
          </Link>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
};

export default Header1;
